import { render, staticRenderFns } from "./CreateWithoutClient.vue?vue&type=template&id=faaf66a0&scoped=true"
import script from "./CreateWithoutClient.vue?vue&type=script&lang=js"
export * from "./CreateWithoutClient.vue?vue&type=script&lang=js"
import style0 from "./CreateWithoutClient.vue?vue&type=style&index=0&id=faaf66a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaf66a0",
  null
  
)

export default component.exports